<template>
  <div>
    <RealtimePerformance />

    <Statistics class="mt-3" @export="handleStatisticsExport">
      <template #status="{ statusStatisticData, loading }">
        <template v-if="statusStatisticData">
          <StatusStatistics :status-statistic-data="statusStatisticData" :loading="loading" />
        </template>
      </template>

      <template #agent="{ agentStatistics, loading }">
        <template v-if="agentStatistics">
          <AgentStatistics
            :bot-data="agentStatistics.botData"
            :agent-data="agentStatistics.agentData"
            :loading="loading"
            :closed-by-bot="agentStatistics.bot_ans"
            :closed-by-agent="agentStatistics.admin_ans"
            :total="agentStatistics.total_ans"
          />
        </template>
      </template>

      <template #response="{ responseStatistics, loading }">
        <template v-if="responseStatistics">
          <ResponseStatistics
            :received="responseStatistics.received"
            :resolved="responseStatistics.resolved"
            :average-first-response-time="responseStatistics.averageFirstResponseTime"
            :average-resolved-ticket-time="responseStatistics.averageResolvedTicketTime"
            :loading="loading"
          />
        </template>
      </template>
      <template #topQuestion="{ filter }">
        <TopQuestion
          class="mt-5"
          :filter="filter"
          @export="handleTopQuestionExport"
          @view="handleTopQuestionView"
        />
        <template v-if="currentQuestion">
          <QuestionDialog
            :filters="filter"
            :open.sync="questionDialog.isOpen"
            :topic="currentQuestion.topic"
            :items="questionDialog.items"
            :pagination.sync="questionDialog.pagination"
            @chat="handleQuestionDialogChat"
            @update:pagination="handleQuestionDialogPaginationUpdate"
          />
        </template>
      </template>
    </Statistics>
  </div>
</template>

<script>
import moment from 'moment'
import RealtimePerformance from './RealtimePerformance.vue'
import Statistics from './Statistics.vue'
import StatusStatistics from './StatusStatistics.vue'
import AgentStatistics from './AgentStatistics.vue'
import ResponseStatistics from './ResponseStatistics.vue'
import TopQuestion from './TopQuestion.vue'

import QuestionDialog from './QuestionDialog.vue'
import XLSX from 'xlsx'
import ttbApi from '@/api/ttb'
import { mapGetters } from 'vuex'

export default {
  name: 'OverviewVue',
  components: {
    RealtimePerformance,
    Statistics,
    StatusStatistics,
    AgentStatistics,
    ResponseStatistics,
    TopQuestion,
    QuestionDialog
  },
  data() {
    return {
      questionDialog: {
        isOpen: false,
        topic: 'Topic',
        items: Array(10)
          .fill()
          .map((value, index) => ({
            id: index + 1,
            ticketNo: 123456,
            avatar: '//via.placeholder.com/512x768',
            name: 'display_name',
            subject: 'subject',
            page: 'page',
            status: 'status',
            channel: ['facebook', 'line'][Math.floor(Math.random() * 2)],
            period: moment().toISOString()
          })),
        pagination: {
          totalItems: 100
        }
      },
      currentQuestion: undefined
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  methods: {
    handleGetPercentage(value = 0, total = 0) {
      value = typeof value == 'string' ? parseInt(value) : value
      total = typeof total == 'string' ? parseInt(total) : total
      if (total === 0) return '0%'
      return `${Math.round((value / total) * 100)}%`
    },
    async handleStatisticsExport(items) {
      const { filter } = items
      try {
        const response = await ttbApi.getReportOverview({
          params: {
            ...filter,
            role: filter.role || undefined,
            channel: filter.channel || undefined,
            search_page_id: filter.search_page_id || undefined,
            date_from: filter.startTime ? moment(filter.startTime).format('YYYY-MM-DD') : undefined,
            date_to: filter.endTime ? moment(filter.endTime).format('YYYY-MM-DD') : undefined,
            page_id: this.selectedBot.pageid
          }
        })
        if (response.status == 200) {
          const all_page_data = response.data
            ? response.data.all_page_data
            : {
                status: {
                  pending: 0,
                  answered: 0,
                  closed_with_survey: 0,
                  closed_without_survey: 0,
                  cancelled_by_customer: 0,
                  closed_by_system: 0
                },
                received: 0,
                resolved: 0,
                first_response: 0,
                number_of_case_by_agent: 0,
                number_of_case_by_bot: 0,
                sum_first_response_time: 0,
                sum_resolved_time: 0,
                average_first_response_time: 0,
                average_resolved_time: 0
              }

          const page_data = response.data ? response.data.page_data : {}
          const channel_data = response.data
            ? response.data.channel_data
            : {
                facebook: {
                  status: {
                    pending: 0,
                    answered: 0,
                    closed_with_survey: 0,
                    closed_without_survey: 0,
                    cancelled_by_customer: 0,
                    closed_by_system: 0,
                    pending_percent: 0,
                    answered_percent: 0,
                    cancelled_by_customer_percent: 0,
                    closed_with_survey_percent: 0,
                    closed_without_survey_percent: 0,
                    closed_by_system_percent: 0
                  },
                  received: 0,
                  resolved: 0,
                  first_response: 0,
                  number_of_case_by_agent: 0,
                  number_of_case_by_bot: 0,
                  sum_first_response_time: 0,
                  sum_resolved_time: 0,
                  number_of_case_by_agent_percent: 0,
                  number_of_case_by_bot_percent: 0,
                  resolved_percent: 0,
                  received_percent: 0,
                  average_first_response_time: 0,
                  average_resolved_time: 0,
                  average_first_response_time_percent: 0,
                  average_resolved_time_percent: 0
                },
                line: {
                  status: {
                    pending: 0,
                    answered: 0,
                    closed_with_survey: 0,
                    closed_without_survey: 0,
                    cancelled_by_customer: 0,
                    closed_by_system: 0,
                    pending_percent: 0,
                    answered_percent: 0,
                    cancelled_by_customer_percent: 0,
                    closed_with_survey_percent: 0,
                    closed_without_survey_percent: 0,
                    closed_by_system_percent: 0
                  },
                  received: 0,
                  resolved: 0,
                  first_response: 0,
                  number_of_case_by_agent: 0,
                  number_of_case_by_bot: 0,
                  sum_first_response_time: 0,
                  sum_resolved_time: 0,
                  number_of_case_by_agent_percent: 0,
                  number_of_case_by_bot_percent: 0,
                  resolved_percent: 0,
                  received_percent: 0,
                  average_first_response_time: 0,
                  average_resolved_time: 0,
                  average_first_response_time_percent: 0,
                  average_resolved_time_percent: 0
                }
              }
          // convert object to array
          const channel_data_array = []
          for (const key in channel_data) {
            if (Object.hasOwnProperty.call(channel_data, key)) {
              const element = channel_data[key]
              channel_data_array.push({ ...element, key })
            }
          }
          const page_data_array = []
          for (const key in page_data) {
            if (Object.hasOwnProperty.call(page_data, key)) {
              const element = page_data[key]
              page_data_array.push({ ...element, key })
            }
          }
          console.log(page_data_array)
          const aoa = []
          aoa.push(['overview'])
          aoa.push([
            `From ${
              filter.startTime ? moment(filter.startTime).format('DD/MM/YYYY HH:mm') : ''
            } to ${filter.endTime ? moment(filter.endTime).format('DD/MM/YYYY HH:mm') : ''}`
          ])
          aoa.push(['status', 'page'])

          aoa.push([
            '',
            ...(page_data_array.length > 1 ? ['All'] : []),
            ...page_data_array
              .map((el) => [
                el.page_name,
                ...(page_data_array.length > 1 ? ['Percentage (%)'] : [])
              ])
              .reduce((a, b) => a.concat(b), [])
          ])

          aoa.push([
            'pending',
            ...(page_data_array.length > 1 ? [all_page_data.status['pending'] || 0] : []),
            ...page_data_array
              .map((el) => [
                el.status['pending'] || 0,
                ...(page_data_array.length > 1 ? [el.status['pending_percent'] || 0] : [])
              ])
              .reduce((a, b) => a.concat(b), [])
          ])
          aoa.push([
            'answered',
            ...(page_data_array.length > 1 ? [all_page_data.status['answered'] || 0] : []),
            ...page_data_array
              .map((el) => [
                el.status['answered'] || 0,
                ...(page_data_array.length > 1 ? [el.status['answered_percent'] || 0] : [])
              ])
              .reduce((a, b) => a.concat(b), [])
          ])
          aoa.push([
            'closed with survey',
            ...(page_data_array.length > 1
              ? [all_page_data.status['closed_with_survey'] || 0]
              : []),
            ...page_data_array
              .map((el) => [
                el.status['closed_with_survey'] || 0,
                ...(page_data_array.length > 1
                  ? [el.status['closed_with_survey_percent'] || 0]
                  : [])
              ])
              .reduce((a, b) => a.concat(b), [])
          ])
          aoa.push([
            'closed without survey',
            ...(page_data_array.length > 1
              ? [all_page_data.status['closed_without_survey'] || 0]
              : []),
            ...page_data_array
              .map((el) => [
                el.status['closed_without_survey'] || 0,
                ...(page_data_array.length > 1
                  ? [el.status['closed_without_survey_percent'] || 0]
                  : [])
              ])
              .reduce((a, b) => a.concat(b), [])
          ])
          aoa.push([
            'closed by SLA',
            ...(page_data_array.length > 1 ? [all_page_data.status['closed_by_system'] || 0] : []),
            ...page_data_array
              .map((el) => [
                el.status['closed_by_system'] || 0,
                ...(page_data_array.length > 1 ? [el.status['closed_by_system_percent'] || 0] : [])
              ])
              .reduce((a, b) => a.concat(b), [])
          ])
          aoa.push([
            'number of case by agent',
            ...(page_data_array.length > 1 ? [all_page_data['number_of_case_by_agent'] || 0] : []),
            ...page_data_array
              .map((el) => [
                el['number_of_case_by_agent'] || 0,
                ...(page_data_array.length > 1 ? [el['number_of_case_by_agent_percent'] || 0] : [])
              ])
              .reduce((a, b) => a.concat(b), [])
          ])
          aoa.push([
            'number of case by bot',
            ...(page_data_array.length > 1 ? [all_page_data['number_of_case_by_bot'] || 0] : []),
            ...page_data_array
              .map((el) => [
                el['number_of_case_by_bot'] || 0,
                ...(page_data_array.length > 1 ? [el['number_of_case_by_bot_percent'] || 0] : [])
              ])
              .reduce((a, b) => a.concat(b), [])
          ])

          aoa.push([
            'received',
            ...(page_data_array.length > 1 ? [all_page_data['received'] || 0] : []),
            ...page_data_array
              .map((el) => [
                el['received'] || 0,
                ...(page_data_array.length > 1 ? [el['received_percent'] || 0] : [])
              ])
              .reduce((a, b) => a.concat(b), [])
          ])
          aoa.push([
            'resolved',
            ...(page_data_array.length > 1 ? [all_page_data['resolved'] || 0] : []),
            ...page_data_array
              .map((el) => [
                el['resolved'] || 0,
                ...(page_data_array.length > 1 ? [el['resolved_percent'] || 0] : [])
              ])
              .reduce((a, b) => a.concat(b), [])
          ])
          aoa.push([
            'average rirst response time',
            ...(page_data_array.length > 1
              ? [all_page_data['average_first_response_time'] || 0]
              : []),
            ...page_data_array
              .map((el) => [
                el['average_first_response_time'] || 0,
                ...(page_data_array.length > 1
                  ? [el['average_first_response_time_percent'] || 0]
                  : [])
              ])
              .reduce((a, b) => a.concat(b), [])
          ])
          aoa.push([
            'average first resolved time',
            ...(page_data_array.length > 1 ? [all_page_data['average_resolved_time'] || 0] : []),
            ...page_data_array
              .map((el) => [
                el['average_resolved_time'] || 0,
                ...(page_data_array.length > 1 ? [el['average_resolved_time_percent'] || 0] : [])
              ])
              .reduce((a, b) => a.concat(b), [])
          ])

          const data = XLSX.utils.aoa_to_sheet(aoa)

          const wb = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(wb, data)
          XLSX.writeFile(wb, `overview_data.xlsx`)
        }
      } catch (error) {
        this.$swal.fire({
          title: this.$t('Something went wrong'),
          text: error.toString(),
          type: 'error',
          confirmButtonText: this.$t('Confirm'),
          cancelButtonText: this.$t('cancel'),
          reverseButtons: true
        })
      }
    },
    handleTopQuestionExport(items) {
      const data = XLSX.utils.json_to_sheet(
        items.map((el) => ({
          Topic: el.topic,
          Received: el.recrived,
          'Received Percentage': `${Math.round(el.recrived_percent || 0)}%`,
          Resolved: el.resolved,
          'Resolved Percentage': `${Math.round(el.resolved_percent || 0)}%`
        }))
      )
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, data)
      XLSX.writeFile(wb, `top_question.xlsx`)
    },
    handleTopQuestionView(item) {
      this.questionDialog.isOpen = true
      this.currentQuestion = item
    },
    handleQuestionDialogChat() {
      // console.log('question dialog chat', data)
    },
    handleQuestionDialogPaginationUpdate() {
      // console.log('question dialog pagination update', pagination)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/features/ttb/DashboardNonvoice/Overview/index.vue